import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "../../../styles";

export const entryTitleStyles = style({
  display: "grid",
  "@media": {
    [`screen and (min-width: ${breakpoints[2]})`]: {
      gap: vars.space["2xs"],
    },
  },
});

export const entryName = style({
  overflowWrap: "anywhere",
  fontSize: vars.fontSizes.heading["2xl"],
});

export const playerNameWrapper = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.xs,
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.body.m,
});
